import { useState } from "react";
import { urlArrayToShareFiles } from "./file-utils";

export const WEBSHARE_DEBUG = false;

export const webShareAvailable = () => {
	return navigator.share !== undefined || WEBSHARE_DEBUG;
};

export const useWebshare = () => {
	const [webshareLoading, setWebshareLoading] = useState(false);

	const share = async (data) => {
		if (webshareLoading) {
			return;
		}

		if (!navigator.share) {
			console.error(
				`[WEB-SHARE] Web Share API is not supported in this browser. Can't perform share action on data \`${JSON.stringify(
					data
				)}.\``
			);
			return;
		}

		setWebshareLoading(true);

		try {
			const dataCopy = { ...data };

			const urlsAsFileArray = await urlArrayToShareFiles(dataCopy.files);

			// null = error
			// undefined projde, jsme bez souborů
			if (urlsAsFileArray === null) {
				setWebshareLoading(false);
				return;
			}

			dataCopy.files = urlsAsFileArray;

			if (WEBSHARE_DEBUG) {
				setWebshareLoading(false);
				console.log("[INTERACTIVE-PRODUCTS] Webshare: sharing data", dataCopy);
				return;
			}

			await navigator.share(dataCopy);
			setWebshareLoading(false);
			// Handlování případných errorů
			// některé zařízení vrací v rámci navigator.share
			// errorové exceptiony, které např. mohou
			// znamenat zavření share okna
		} catch (err) {
			console.error("[WEB-SHARE] Error while sharing", err);
			setWebshareLoading(false);
		}
	};

	return {
		share,
		webshareLoading,
	};
};
